import { Box, Grid, Paper, Typography } from "@mui/material";
import { getCurrentFormattedDateTime } from "../helpers/weather-helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CurrentWeather, DAY_NIGHT_TEXT_COLOR, HourlyWeather, HourlyWeatherUnit, weatherCodes } from "../types/Weather";
import HourlyWeatherSlider from "./HourlyWeatherSlider";

const TodayWeatherMainSection = ({ currentWeather, todayHourlyWeather, hourlyWeatherUnit }: {
  currentWeather: CurrentWeather,
  todayHourlyWeather: HourlyWeather[],
  hourlyWeatherUnit: HourlyWeatherUnit,
}) => {
  const currentWeatherCode = weatherCodes.get(todayHourlyWeather[0].weathercode);

  return (
    <Paper
      variant="outlined"
      sx={{
        borderColor: DAY_NIGHT_TEXT_COLOR,
        borderRadius: '16px',
        paddingX: 2,
        paddingY: 4,
        color: DAY_NIGHT_TEXT_COLOR,
        backgroundColor: currentWeather.is_day ? currentWeatherCode?.dayColor : currentWeatherCode?.nightColor
      }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="body1" sx={{ fontWeight: '600' }}>{getCurrentFormattedDateTime()}</Typography>
        </Grid>
        <Grid item xs={12} >
          <Grid container spacing={2} sx={{ paddingLeft: 2, paddingRight: 0 }}>
            <Grid item xs={6} >
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Typography variant="h1" >{todayHourlyWeather[0].temperature_2m.toFixed(0)}</Typography>
                <Typography variant="h5" paddingTop={2}>{hourlyWeatherUnit?.temperature_2m}</Typography>
              </Box>
            </Grid>
            <Grid item xs={6} sx={{ textAlign: "center" }}>
              <FontAwesomeIcon
                style={{ paddingTop: 20, paddingBottom: 8 }}
                icon={currentWeather.is_day ? currentWeatherCode?.dayIcon! : currentWeatherCode?.nightIcon!}
                size="3x" />
              <Typography variant="body1">{currentWeatherCode?.text}</Typography>
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ textAlign: "left" }}>
            <Grid item xs={12} >
              <Typography variant="caption" sx={{ paddingX: 2 }}>
                Feels like {todayHourlyWeather[0].apparent_temperature.toFixed(0)}{hourlyWeatherUnit?.apparent_temperature}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <HourlyWeatherSlider hourlyWeather={todayHourlyWeather} />
    </Paper>
  );
}

export default TodayWeatherMainSection;